<template>
  <div class="row">
    <div class="col-12">
      <DayScheduleItemsTable :selected_day_schedule_id="scopedSelectedDayScheduleId"></DayScheduleItemsTable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DayScheduleItemsTable from '../../../components/Scheduler/Day/DayScheduleItemsTable'

export default {
  components: { DayScheduleItemsTable },
  data: function () {
    return {
      scopedSelectedDayScheduleId: 0
    }
  },
  computed: {
    ...mapGetters({
      selected_day_schedule_id: 'selectedDayScheduleId'
    })
  },
  created () {
    this.scopedSelectedDayScheduleId = this.selected_day_schedule_id
  }
}
</script>

<style scoped>
</style>
